import { render, staticRenderFns } from "./challengeItem.vue?vue&type=template&id=35e659de&scoped=true&"
import script from "./challengeItem.vue?vue&type=script&lang=js&"
export * from "./challengeItem.vue?vue&type=script&lang=js&"
import style0 from "./challengeItem.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./challengeItem.vue?vue&type=style&index=1&id=35e659de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e659de",
  null
  
)

export default component.exports